import { type FormTransferPackage, formTransferPackageSchema } from '@skewb-works/contracts';

export type ParsedFormTransferFile =
  | { ok: true; data: FormTransferPackage }
  | { ok: false; message: string };

const MAX_FORM_TRANSFER_FILE_MB = 10;

export const MAX_FORM_TRANSFER_FILE_BYTES = MAX_FORM_TRANSFER_FILE_MB * 1024 * 1024;
export const MAX_FORM_TRANSFER_FILE_LABEL = `${MAX_FORM_TRANSFER_FILE_MB} MB`;

export function parseFormTransferFile(text: string): ParsedFormTransferFile {
  let json: unknown;
  try {
    json = JSON.parse(text);
  } catch {
    return { ok: false, message: 'The file is not valid JSON.' };
  }
  const result = formTransferPackageSchema.safeParse(json);
  if (!result.success) {
    const issue = result.error.issues[0];
    return {
      ok: false,
      message: `This is not a valid form export (${issue.path.join('.') || 'file'}: ${issue.message}).`,
    };
  }
  return { ok: true, data: result.data };
}

export function buildExportFilename(formName: string): string {
  const slug = formName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return `${slug || 'form'}.skewb-form.json`;
}
